import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";
import Announcements from "./index";
import ViewAnnouncement from "./view";
import EditAnnouncement from "./edit";

import { MODULE_ANNOUNCEMENTS } from "variables/modules";

const announcementRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Announcements",
		basePath: "announcements",
		mainComponent: <Announcements />,
	    layout: "/console",	   
	    subTitle:"Announcements",
	    createComponent: <EditAnnouncement />,
		viewComponent: <ViewAnnouncement/>,
	    editComponent: <EditAnnouncement />,
		level:3,
		moduleId: MODULE_ANNOUNCEMENTS,
	})
]

export default announcementRoutes;